import {
  R_APPLY, R_CAREERS, R_SAS_TRAININGS, R_VACANCIES, R_VACANCIES_DETAILS, R_APPLY_SAS,
} from '../routes';

const Careers = () => import(/* webpackChunkName: "Careers" */ '@/views/Careers/Careers');
const Vacancies = () => import(/* webpackChunkName: "Vacancies" */ '@/views/Careers/Vacancies');
const VacancyDetails = () => import(/* webpackChunkName: "VacancyDetails" */ '@/views/Careers/VacancyDetails');
const Apply = () => import(/* webpackChunkName: "Apply" */ '@/views/Careers/Apply');
const SASTrainings = () => import(/* webpackChunkName: "SASTrainings" */ '@/views/Careers/SASTrainings');

export default {
  path: '/careers',
  component: {
    render(c) {
      return c('router-view');
    },
  },
  children: [
    {
      path: '',
      component: {
        render(c) {
          return c('router-view');
        },
      },
      children: [
        {
          name: R_CAREERS,
          path: '',
          meta: {
            title: 'Careers',
          },
          component: Careers,
        },
        {
          path: 'vacancies',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            title: 'Careers',
          },
          children: [
            {
              name: R_VACANCIES,
              path: '',
              meta: {
                title: 'Vacancies',
              },
              component: Vacancies,
            },
            {
              name: R_APPLY,
              path: 'apply',
              meta: {
                title: 'Apply',
              },
              component: Apply,
            },
            {
              name: R_VACANCIES_DETAILS,
              path: 'vacancy-details',
              meta: {
                title: 'Vacancies',
              },
              component: VacancyDetails,
            },
          ],
        },
        {
          path: 'sas-trainings',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            title: 'Sas-trainings',
          },
          children: [
            {
              name: R_SAS_TRAININGS,
              path: '',
              meta: {
                title: 'Sas-trainings',
              },
              component: SASTrainings,
            },
            {
              name: R_APPLY_SAS,
              path: 'apply',
              meta: {
                title: 'Apply',
              },
              component: Apply,
            },
          ],
        },
      ],
    },

  ],
};
